
export const wifiOff = 'wifiOff'
